module.exports = __webpack_public_path__ + "img/file03.67042606.png";